class Form {
	handleErrors(form, response) {
		let errors = response.responseJSON.errors;
		if (errors) {
			Helpers.Message.wrongInputError();
			for (let field in errors) {
				form.errors[field] = errors[field][0];
			}
		} else {
			Helpers.Message.error(response.responseJSON.message);
		}
	}
}

export default Form;